import { JumpTarget, useJump } from '@/components/MagicJump';
import ClientOnly from '@/components/Responsive/ClientOnly';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useReporting } from '@/hooks/useReporting';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { getRouteCnName } from '@/utils/route-metadata';
import { setCampaignEntrancePageScene } from '@/utils/tracking/entrancePageScene';
import { useEffect, useMemo, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { HeaderProps } from '..';
import CountDown from './CountDown';

const DingTong = (props: HeaderProps) => {
  const { dtInfo } = props;
  const token = useStore((state) => state.token);
  const isShowDtBanner = useStore((state) => state.isShowDtBanner);
  const [finalDtInfo, setFinalDtInfo] = useState(dtInfo);
  const [serverTime] = useState(finalDtInfo.server_time);
  const [isCountDownEnded, setIsCountDownEnded] = useState(false);
  const { trackEvent } = useReporting();
  const toJumpTarget = useJump();

  useEffect(() => {
    if (token) {
      setFinalDtInfo((dtInfo as { content_login: HeaderProps['dtInfo'] }).content_login);
    } else {
      setFinalDtInfo(dtInfo);
    }
  }, [dtInfo, token]);

  const finalIsShowDtBanner = useMemo(() => {
    // 检查是否到了开始显示时间
    const isAfterStartTime =
      !finalDtInfo.start_time_TUC_5_unix || finalDtInfo.start_time_TUC_5_unix <= serverTime;
    return isShowDtBanner && finalDtInfo.position_status === 1 && isAfterStartTime;
  }, [isShowDtBanner, finalDtInfo, serverTime]);

  const isShowCountDown = () => {
    if (
      finalDtInfo.count_down_status === 1 &&
      (finalDtInfo.deadline_time_TUC_5_unix - serverTime) / 1000 > 0 &&
      finalDtInfo.start_time_TUC_5_unix <= serverTime
    ) {
      return true;
    }
    return false;
  };

  const handleClick = () => {
    setCampaignEntrancePageScene('顶通', finalDtInfo.Jump_target);

    trackEvent(
      {
        eventName: 'DingTong_Click',
        properties: {
          page_name: getRouteCnName(location.pathname),
          jump_type: finalDtInfo.jump_type,
          jump_content: `${(finalDtInfo.sku as unknown as { shop_sku: string }).shop_sku || (finalDtInfo.product_group as unknown as { id: string }).id || finalDtInfo.Jump_target}`,
        },
      },
      [ProviderType.SENSORS],
    );

    // TODO: 有一个类型有问题
    toJumpTarget(finalDtInfo as unknown as JumpTarget);
  };

  return (
    <InView
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          trackEvent(
            {
              eventName: 'DingTong_Exp',
              properties: {
                page_name: getRouteCnName(location.pathname),
                jump_type: finalDtInfo.jump_type,
                jump_content: `${(finalDtInfo.sku as unknown as { shop_sku: string }).shop_sku || (finalDtInfo.product_group as unknown as { id: string }).id || finalDtInfo.Jump_target}`,
              },
            },
            [ProviderType.SENSORS],
          );
        }
      }}
    >
      <WapOnly>
        <div
          className={`w-full overflow-hidden transition-all cursor-pointer duration-300 ${!finalIsShowDtBanner ? 'h-[0px]' : 'h-[10.667vw]'}`}
          onClick={handleClick}
        >
          <div
            className="DingTong w-full m-[0_auto] relative overflow-hidden flex items-center justify-center h-[9.600vw]"
            style={{
              backgroundColor: (finalDtInfo as { bg_color: string }).bg_color,
            }}
          >
            <span className="text-[3.2vw] text-primary-white max-w-[70vw] overflow-hidden text-ellipsis whitespace-nowrap">
              {(finalDtInfo as { dt_text: string }).dt_text}
            </span>
            {isShowCountDown() && !isCountDownEnded ? (
              <div
                className="flex ml-[5.333vw]"
                style={{
                  color: finalDtInfo.number_color,
                }}
              >
                <ClientOnly>
                  <CountDown
                    time={(finalDtInfo.deadline_time_TUC_5_unix - serverTime) / 1000}
                    textColor={finalDtInfo.text_color}
                    onCountDownEnd={() => setIsCountDownEnded(true)}
                  />
                </ClientOnly>
              </div>
            ) : (
              <span className="text-[3.2vw] text-primary-white underline ml-[5.333vw]">
                {(finalDtInfo as { shop_now_text: string }).shop_now_text}
              </span>
            )}
          </div>
        </div>
      </WapOnly>
      <WebOnly>
        <div>
          <div
            className={`flex justify-center items-center ${finalDtInfo.jump_type ? 'cursor-pointer' : ''} relative w-full overflow-hidden transition-all duration-300 ${
              !finalIsShowDtBanner ? 'h-[0px]' : 'h-[34px]'
            }`}
            style={{
              backgroundColor: (finalDtInfo as { bg_color: string }).bg_color,
            }}
            onClick={handleClick}
          >
            <span className="text-primary-white text-12">
              {(finalDtInfo as { dt_text: string }).dt_text}
            </span>
            {isShowCountDown() && !isCountDownEnded ? (
              <ClientOnly>
                <CountDown
                  time={(finalDtInfo.deadline_time_TUC_5_unix - serverTime) / 1000}
                  textColor={finalDtInfo.text_color}
                  onCountDownEnd={() => setIsCountDownEnded(true)}
                />
              </ClientOnly>
            ) : (
              <span className="text-primary-white text-12 ml-[72px] underline">
                {(finalDtInfo as { shop_now_text: string }).shop_now_text}
              </span>
            )}
          </div>
        </div>
      </WebOnly>
    </InView>
  );
};

export default DingTong;
